// extracted by mini-css-extract-plugin
export var container = "Accordion-module--container--GAxPh";
export var item = "Accordion-module--item--DZupz";
export var question = "Accordion-module--question--+gzdJ";
export var response = "Accordion-module--response--YyMZc";
export var toggle = "Accordion-module--toggle--+anU0";